const $ = jQuery.noConflict();

function isTouchDevice() {
	return 'ontouchstart' in window || navigator.msMaxTouchPoints;
}
class MegaMenu {
	constructor() {
		this.menu = $('.main-header__nav');
		this.menuItems = this.menu.find('> .menu > .menu-item-type-post_type');
		this.menuItemsLinks = this.menuItems.find('> a');
		this.header = $('.main-header'); // Make sure to define this.header in the constructor
	}
	static showMegaMenu() {
		const megaMenuWrapper = $(this).find('.mega-menu-wrapper');
		const megaMenuCols = megaMenuWrapper.find('[class*="col-"]');
		const timer =
			$('.main-header .mega-menu-background').height() !== 0 ? 0 : 250;

		MegaMenu.menuTimeout = setTimeout(() => {
			megaMenuCols.each((i, v) => {
				MegaMenu.animateItemsIn($(v).find('*'));
			});
			megaMenuWrapper.addClass('active');
		}, timer);
	}
	static hideMegaMenu() {
		clearTimeout(MegaMenu.menuTimeout);
		const activeMegaMenu = $('.mega-menu-wrapper.active');
		const activeMegaMenuItems = activeMegaMenu.find('*');

		activeMegaMenu.removeClass('active');
		activeMegaMenuItems.removeClass('active');
	}
	static hideMegaMenuOnTouch(e) {
		const container = $('.main-header__nav');
		if (
			!container.is(e.target) &&
			container.has(e.target).length === 0 &&
			$('.mega-menu-wrapper').hasClass('active')
		) {
			MegaMenu.hideMegaMenu();
		}
	}
	static animateItemsIn(items) {
		let delay = 0;
		items.each((i, v) => {
			delay += 0.04;
			$(v).css('transition-delay', `${delay}s`);
			$(v).addClass('active');
		});
	}

	bindEvents() {
		if (isTouchDevice()) {
			this.menuItemsLinks.on('click', this.toggleMegaMenu);
			$(document).on('click touchstart', MegaMenu.hideMegaMenuOnTouch);
		} else {
			this.menuItems.on('mouseenter', function () {
				MegaMenu.showMegaMenu.call(this);
				// eslint-disable-next-line no-console
				console.log(this.menuItems);
				if ($(this).find('ul.sub-menu').length > 0) {
					$('.main-header').addClass('sub-menu-opened');
				}
			});
			this.menuItems.on('mouseleave', function () {
				MegaMenu.hideMegaMenu.call(this);
				$('.main-header').removeClass('sub-menu-opened');
			});
		}

		this.menu.on('mouseenter', () => this.header.addClass('opaque'));
		this.menu.on('mouseleave', () => {
			if (!this.checkIntersection()) {
				this.header.removeClass('opaque');
			}
		});

		// Bind scroll event
		$(window).on('scroll', () => {
			if (
				!this.checkIntersection() &&
				!this.header.hasClass('sub-menu-opened')
			) {
				this.header.removeClass('opaque');
			} else {
				this.header.addClass('opaque');
			}
		});
	}
	checkIntersection() {
		const $bookingHero = $('.home .block-hero-hyline');
		const headerBottom =
			this.header.offset().top + this.header.outerHeight();
		let bookingBottom = 0;
		if ($bookingHero.length > 0) {
			bookingBottom =
				$bookingHero.offset().top + $bookingHero.outerHeight();
			return headerBottom > bookingBottom;
		}
		return true;
	}

	toggleMegaMenu(e) {
		e.preventDefault();
		const megaMenuWrapper = $(this).next('.mega-menu-wrapper');

		if (megaMenuWrapper.hasClass('active')) {
			return;
		}

		const megaMenuCols = megaMenuWrapper.find('[class*="col-"]');

		MegaMenu.hideMegaMenu();
		megaMenuCols.each((i, v) => {
			MegaMenu.animateItemsIn($(v).find('*'));
		});

		megaMenuWrapper.addClass('active');
		// MegaMenu.animateMenuBackground(megaMenuWrapper.outerHeight());
	}
	init() {
		this.bindEvents();
	}
}
export default new MegaMenu();
